<app-dashboard-header></app-dashboard-header>

<div class="resourceattributes-content">
  <h1 class="page-title">Resource Attributes</h1>
  
  <mat-card>
    <div class="card-header">
      <h2>Manage Attributes for {{ resourceTypeName }}</h2>
      <div class="header-actions">
        <button mat-stroked-button class="back-button" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Back
        </button>
        <button mat-flat-button class="action-button accent" (click)="openAddDialog()">
          <mat-icon>add</mat-icon>
          Add Attribute
        </button>
      </div>
    </div>

      <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40"></mat-progress-spinner>

      <div *ngIf="error" class="error-message">
        {{ error }}
      </div>

      <div *ngIf="!loading && resourceAttributes.length > 0" class="table-container">
        <table mat-table [dataSource]="resourceAttributes | sort:'order'" cdkDropList
               (cdkDropListDropped)="onDrop($event)"
               style="width: 100%;">

          <!-- Drag Column -->
          <ng-container matColumnDef="drag">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let attribute">
              <mat-icon *ngIf="!attribute.external" cdkDragHandle class="drag-handle">drag_indicator</mat-icon>
              <mat-icon *ngIf="attribute.external" class="drag-handle disabled" matTooltip="External attributes cannot be reordered">drag_indicator</mat-icon>
            </td>
          </ng-container>

          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let attribute">{{ attribute.id }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let attribute">
              <div style="display: flex; flex-direction: column;">
                <span>
                  {{ attribute.name }}
                  <span *ngIf="attribute.external" class="external-badge" matTooltip="Managed via SSO">SSO</span>
                </span>
                <span style="font-size: 0.75em; color: #888; opacity: 0.7;">{{ attribute.slug || '-' }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let attribute">
              {{ attribute.type || 'text' }}
            </td>
          </ng-container>


          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 180px;">Actions</th>
            <td mat-cell *matCellDef="let attribute">
              <button mat-icon-button color="primary"
                      [matTooltip]="attribute.external ? 'External attributes cannot be edited' : 'Edit'"
                      [disabled]="attribute.external"
                      (click)="openEditDialog(attribute); $event.stopPropagation();">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn"
                      [matTooltip]="attribute.external ? 'External attributes cannot be deleted' : 'Delete'"
                      [disabled]="attribute.external"
                      (click)="deleteResourceAttribute(attribute); $event.stopPropagation();">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              cdkDrag [cdkDragData]="row" class="draggable-row"
              cdkDragPreviewClass="custom-drag-preview"></tr>
        </table>
      </div>
      <div *ngIf="!loading && resourceAttributes.length === 0" class="no-attributes">
        <mat-icon>info</mat-icon>
        <p>No attributes found for this resource type. Click the "Add Attribute" button to create your first attribute.</p>
      </div>
  </mat-card>
</div>

<app-dashboard-footer></app-dashboard-footer>
